module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart-contaier"
  }, [_c('div', {
    staticClass: "widgets-addition-action"
  }, [_c('el-select', {
    staticClass: "widget-filterBy",
    attrs: {
      "placeholder": "Select",
      "size": "small"
    },
    on: {
      "change": function($event) {
        return _vm.updateChart($event)
      }
    },
    model: {
      value: (_vm.filterBySelected),
      callback: function($$v) {
        _vm.filterBySelected = $$v
      },
      expression: "filterBySelected"
    }
  }, _vm._l((_vm.filterBy), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.loaded) ? _c('bar-chart', {
    attrs: {
      "chartdata": _vm.chartdata,
      "options": _vm.options
    }
  }) : _c('div', {
    staticClass: "loading"
  }, [_c('i', {
    staticClass: "el-icon-loading"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24423e0b","hasScoped":false}!./src/app/components/widgets/topClients/topClients.html
// module id = 2944
// module chunks = 1